export const distributorPortalBaseUrl = process.env.REACT_APP_BASE_URL + "/businessPartner/";
export const apiDisability = (process.env.NODE_ENV === "production")? "":"fffffff";